var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { pageRoot: true, noMargin: !!_vm.validatedProjectName } },
    [
      _vm.error
        ? _c("div", { staticClass: "error" }, [_vm._v(_vm._s(_vm.error))])
        : _vm.loading
        ? _c(
            "div",
            { staticClass: "loading" },
            [_c("ScaleLoader"), _vm._v(" Loading…")],
            1
          )
        : _vm.validatedProjectName
        ? _c(
            "div",
            [
              _c("ProjectDisplay", {
                attrs: {
                  projectName: _vm.validatedProjectName,
                  selectedFolderId: _vm.selectedFolderId,
                  openedEventId: _vm.openedEventId,
                  selectedEventIds: _vm.selectedEventIds,
                  searchArgs: _vm.searchArgs,
                  uniqueOnly: _vm.uniqueOnly
                }
              })
            ],
            1
          )
        : _c("div", [
            _c("div", { staticClass: "heading" }, [_vm._v("Select a Project")]),
            _vm._v(" "),
            _c("div", { staticClass: "bodySection" }, [
              _vm.projects && _vm.projects.length > 0
                ? _c(
                    "div",
                    _vm._l(_vm.projects, function(p) {
                      return _c(
                        "div",
                        { key: p.Name, staticClass: "projectListItem" },
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                to: { name: "clientHome", query: { p: p.Name } }
                              }
                            },
                            [_vm._v(_vm._s(p.Name))]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "projectMetadata" }, [
                            _vm._v(
                              _vm._s(p.EventCount) +
                                " Events, " +
                                _vm._s(p.UniqueEventCount) +
                                " Unique"
                            )
                          ])
                        ],
                        1
                      )
                    }),
                    0
                  )
                : _c("div", [
                    _vm._v(
                      "\n\t\t\t\tNo projects are accessible by your user account.\n\t\t\t"
                    )
                  ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "heading" }, [
              _vm._v("Manage User Account")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "bodySection" }, [
              _c(
                "div",
                [
                  _c(
                    "router-link",
                    { attrs: { to: { name: "changePassword" } } },
                    [_vm._v("Change Password")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.mcpEnabled
                ? _c(
                    "div",
                    [
                      _c(
                        "router-link",
                        { attrs: { to: { name: "apiTokens" } } },
                        [_vm._v("API Tokens (for AI agents)")]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "heading" }, [_vm._v("Tips")]),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "heading" }, [_vm._v("Login History")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "bodySection" },
              [_c("LoginRecordsTable")],
              1
            )
          ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bodySection" }, [
      _c("div", [
        _c("ul", [
          _c("li", [
            _vm._v(
              "Most aspects of event management are shared by all users.  Think of it like sharing an email account with others where everyone uses IMAP.  If you move, delete, or recolor an event, it happens for all users."
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "Read/Unread state is unique to each user, however if you set this state via a Filter Action, it will affect all current users."
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "At this time, changes made by other users may not be seen until you refresh the page."
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }